import { useFormDataQuery } from '@/api/getters';
import {
  useFormMutation,
  useSubmitStagesMutation,
  useSubmitStepMutation,
} from '@/api/setters';
import { Stages, Steps } from '@/api/types';
import { formMutationDto } from '@/dto/formMutationDto';
import { BlockOverlayPortal } from '@/features/v2/hh/components/consultantCompleted/ConsultantCompletedStageI';
import { useStepper } from '@/features/v2/lib/stepper';
import { scrollToTop } from '@/helpers/scrollToTop';

const ConsultantCompletedStageII = () => {
  const { isFetching } = useFormDataQuery();

  const { stepTag, setStepTag, setStep, setInnerStep, innerObject } =
    useStepper();

  const submitStages = useSubmitStagesMutation();

  const submitStep = useSubmitStepMutation();
  const updateForm = useFormMutation();

  const { data } = useFormDataQuery();

  const handleFormCompletion = async () => {
    // in case if consultant completed form before user (edge case)
    if (data?.consultant_completed_at?.stage_II) {
      await updateForm
        .mutateAsync({
          ...formMutationDto({
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            form_data: data?.payload?.data as Record<string, any>,
            stepper: {
              step: 2,
              innerStep: {
                [0]: innerObject[0] ?? 0,
                [1]: 0,
                [2]: 0,
              },
            },
          }),
        })
        .then(() => {
          setStep(2);
          setInnerStep({ ...innerObject, [2]: 0 });
          scrollToTop();
        });
    }

    if (!data?.consultant_completed_at?.stage_I) {
      await submitStages.mutateAsync(Stages.STAGE_I_FINISHED);
      scrollToTop();
    }

    if (stepTag === Steps.DOCUMENTS) {
      submitStep.mutateAsync(Steps.ADDITIONAL_INFORMATION).then(() => {
        setStepTag(Steps.ADDITIONAL_INFORMATION);
      });
    }
  };

  return (
    <BlockOverlayPortal
      loading={submitStages.isPending || updateForm.isPending || isFetching}
      handleFormCompletion={handleFormCompletion}
    />
  );
};

export default ConsultantCompletedStageII;
